import { createComponent, Slot } from 'react-commons';
import FeaturedCarousel, { FeaturedCarouselProps } from '@/components/FeaturedCarousel';
import Pod from '@/components/Pod';
import style from './index.module.scss';

interface FeaturedCarouselPodProps extends FeaturedCarouselProps {
  h1?: boolean
}

export default createComponent<FeaturedCarouselPodProps>('FeaturedCarouselPod', { style }, function FeaturedCarouselPod ({ className, slots }, props) {
  return (
    <Pod h1={props.h1} className={className}>
      <Slot name='title'>
        {slots.title}
      </Slot>
      <FeaturedCarousel 
        {...props}          
      />
    </Pod>
  );
});
